import { createFileRoute } from '@tanstack/react-router';
import { TrackEditor } from '@/components/tracks/TrackEditor.tsx';

export const Route = createFileRoute('/_app/tracks/create')({
  staticData: { orgScope: 'required' },
  component: CreateTrackPage,
});

/** A track written from scratch, for the organisation this session belongs to. */
function CreateTrackPage() {
  return <TrackEditor trackId={null} />;
}
